import { forwardRef, Ref, SVGProps } from 'react'

const _IconTool = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...props} ref={ref}>
      <path
        d="M8.38838 3.71738C8.27269 3.83541 8.20788 3.9941 8.20788 4.15937C8.20788 4.32464 8.27269 4.48333 8.38838 4.60136L9.39864 5.61162C9.51667 5.72731 9.67535 5.79212 9.84063 5.79212C10.0059 5.79212 10.1646 5.72731 10.2826 5.61162L12.663 3.23119C12.9805 3.93281 13.0767 4.71453 12.9386 5.47217C12.8006 6.22981 12.4349 6.92739 11.8904 7.47194C11.3458 8.0165 10.6482 8.38216 9.8906 8.5202C9.13296 8.65825 8.35124 8.56212 7.64962 8.24462L3.28655 12.6077C3.03536 12.8589 2.69467 13 2.33943 13C1.98419 13 1.6435 12.8589 1.39231 12.6077C1.14112 12.3565 1 12.0158 1 11.6606C1 11.3053 1.14112 10.9646 1.39231 10.7134L5.75538 6.35038C5.43788 5.64876 5.34175 4.86704 5.4798 4.1094C5.61784 3.35176 5.9835 2.65418 6.52806 2.10962C7.07261 1.56507 7.77019 1.19941 8.52783 1.06136C9.28547 0.92332 10.0672 1.01945 10.7688 1.33695L8.39469 3.71107L8.38838 3.71738Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconTool = forwardRef(_IconTool)
